import naja from 'naja'
window.naja = naja;

import {LiveForm, Nette} from "live-form-validation";
window.LiveForm = LiveForm;
window.Nette = Nette;

import App from '../../vendor/slimshop/core/src/Templates/SlimTemplate/vendor/template/js/template.js'
window.App = App;

import _ from 'lodash'
window._ = _;

import $ from'jquery'
window.$ = $;
window.jQuery = $;

import Swiper from 'swiper/js/swiper.min.js'
window.Swiper = Swiper;

import LazyLoad from "vanilla-lazyload"
window.LazyLoad = LazyLoad;

import noUiSlider from 'nouislider';
window.noUiSlider = noUiSlider;

import PhotoSwipe from 'photoswipe'
window.PhotoSwipe = PhotoSwipe;

import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.js'
window.PhotoSwipeUI_Default = PhotoSwipeUI_Default;

import Bootsrtap from 'bootstrap/dist/js/bootstrap.bundle.min.js'
window.bootstrap = Bootsrtap;


/*
 * node_modules css
 */
import 'swiper/css/swiper.css'
import 'simple-notify/dist/simple-notify.css'
import 'nouislider/distribute/nouislider.css'
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'

/*
 * node_modules js
 */

import 'metismenu'
import 'simple-notify'
import 'wnumb'

/*
 * CORE template css
 */
import './scss/style.scss'
